import React, { useCallback } from 'react';
import { getCleanUrl } from 'js/utils/url.util';
import { useNavigate } from 'js/hooks/navigate';
import { dispatcher } from 'dispatcher';
import { useGameUrlFragment } from './hooks';
import { gameInfoScrollService } from './GameInfoScrollService';

export const withGameInfo = Wrapped => (props) => {
    const navigate = useNavigate();
    const { code, hideButtons, gameLaunchType, showFavoriteIcon } = props;
    const gameUrlFragment = useGameUrlFragment(code);

    const openGameInfo = useCallback(() => {
        const { prevPath } = window.history.state?.state || {};
        const giPath = 'online-game';
        dispatcher.dispatch('openGamesInfoPopupAction');
        gameInfoScrollService.saveScrollTop();
        const state = location.pathname.includes(giPath)
            ? {
                prevPath,
                hideButtons,
                gameLaunchType,
                showFavoriteIcon,
                showBackButton: true
            }
            : {
                hideButtons,
                gameLaunchType,
                showFavoriteIcon,
                prevPath: getCleanUrl()
            };

        navigate(`/${giPath}/${gameUrlFragment}`, state);
    }, [showFavoriteIcon, gameUrlFragment, hideButtons, gameLaunchType, navigate]);

    return (
        <Wrapped
            {...props}
            openGameInfo={openGameInfo}
        />
    );
};
